import Plausible from "plausible-tracker";

export default class PrettyNaoAnalytics {
  private static plausible: ReturnType<typeof Plausible> | null = null;

  static getPlausible() {
    if (PrettyNaoAnalytics.plausible === null) {
      const plausible = Plausible({
        domain: 'prettynao.com',
        apiHost: 'https://straw.tryonhaulcentral.com',
        trackLocalhost: false,
      })
      plausible.enableAutoPageviews()

      PrettyNaoAnalytics.plausible = plausible
    }

    return PrettyNaoAnalytics.plausible
  }
}

